import GiveAway from './GiveAway';

export default GiveAway;
